import { helpers } from '@vuelidate/validators'

export default length =>
  helpers.withParams({ type: 'minArrayLength', min: length }, value => {
    return Array.isArray(value) && value.length >= length
  })
